import {ValueObject} from '@s-ui/domain'

export class GetIsMakeHiredValueObject extends ValueObject {
  #isHired

  constructor({isHired}) {
    super()
    this.#isHired = isHired
  }

  static createFromApi({isHired}) {
    return new GetIsMakeHiredValueObject({isHired})
  }

  get isHired() {
    return this.#isHired
  }
}
